import React from 'react';
import {MutatePractitionerRequest, space} from "../../../../provider_api";
import {useParams} from "react-router-dom";
import {findPractitioner} from "../Calendar/CalendarUtil";
import {EditableStringField} from "../../../../components/Editable/EditableStringField";
import {EditableLongTextField} from "../../../../components/Editable/EditableLongTextField";
import {EditablePhotoUpload} from "../../../../components/Editable/EditablePhotoUpload";
import {getPractitionerName} from "../../../../util/ProviderUtil";
import {KensuProfileEditor} from "../../../../components/table/KensuProfileEditor";
import PractitionerProto = space.kenko.proto.PractitionerProto;
import IPractitionerProto = space.kenko.proto.IPractitionerProto;
import {EditableYesNo} from "../../../../components/Editable/EditableYesNo";
import {getProviderServer} from "../../../../util/HostUtils";
import {useProviderProfile} from "../../../../ProviderProfileProvider";


// This is the page for editing (or adding) a service.
export const AddOrUpdatePractitioner = () => {

  const {business} = useProviderProfile();
  const {providerIdParam} = useParams();

  return <KensuProfileEditor<IPractitionerProto>
      idParam={providerIdParam}
      entityName={'Practitioner'}
      entityListViewLink={'..'}
      archiveField={"archived"}
      getFromProfile={(profile, id) => findPractitioner(profile.practitioners, id)}
      getTitle={bio => getPractitionerName(bio)}
      newBlankType={() => new PractitionerProto()}
      getRpcMethod={isUpdate => isUpdate ? 'update_practitioner' : 'create_practitioner'}
      getRpcPayload={practitioner => MutatePractitionerRequest.encode(
          new MutatePractitionerRequest({
            practitioner: practitioner
          })).finish()}>

    <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>

      <EditableStringField<IPractitionerProto>
          label={'First name'}
          field={'firstName'}
          inputType={'text'}/>

      <EditableStringField<IPractitionerProto>
          label={'Last name'}
          field={'lastName'}
          inputType={'text'}/>

    </div>

    {/* A whole slew of editable fields are only shown if this person is a provider */}
    {/*  an not a business manager. */}
    <EditableLongTextField<IPractitionerProto>
        label={'Biography (Optional)'}
        getter={entity => entity.bio}
        setter={(entity, value) => ({...entity, bio: value})}
        helpText={`Max 500 characters`}
        maxCharacterCount={500}
        field={'bio'}
    />

    <EditableStringField<IPractitionerProto>
        label={'Job title (Optional)'}
        field={'jobTitle'}
        helpText={'Max 50 characters'}
        inputType={'text'}
    />

    <EditablePhotoUpload<IPractitionerProto>
        label={'Team member photo (Optional)'}
        field={"imageUrl"}
        getter={entity => entity.imageUrl}
        setter={(entity, value) => ({...entity, imageUrl: value})}
    />

    {business?.businessSettings?.offersVirtualServices &&
        <EditableStringField<IPractitionerProto>
            label={'Virtual meeting link (Optional)'}
            field={'virtualMeetingLink'}
            helpText={'When booking a virtual service with this practitioner, this meeting link will be used.'}
            inputType={'url'}
        />}

    <EditableYesNo<IPractitionerProto>
        label={'Enable iCalendar export URL'}
        getter={practitioner => !!practitioner.calendarExportKey}
        setter={(practitioner, value) => ({...practitioner, calendarExportKey: value ? 'generate' : ''})}
        helpText={(isEditing, workingCopy) => {
          if (!workingCopy.calendarExportKey || workingCopy.calendarExportKey == 'generate') {
            return 'Enable this to export your schedule to Google Calendar, Apple Calendar, or Outlook.'
          }

          return <>Export is enabled! Copy this URL into Google Calendar, Apple Calendar, or Outlook:
            <p>
              {getProviderServer()}/calendar?b={business?.businessId}&p={workingCopy.practitionerId}&k={workingCopy.calendarExportKey}
            </p>
          </>
        }
        }
    />


  </KensuProfileEditor>;
}